// @flow
import {
  stringRequired,
  emailRequired,
  password,
} from "forms/validators/string"

export const schema = {
  firstName: stringRequired,
  lastName: stringRequired,
  email: emailRequired,
  password: password,
}



// WEBPACK FOOTER //
// ./src/modals/SignUp/SignUpForm/schema.js